import { AuthenticationMethodType } from '@mc-alberta/types';
import { AuthenticationStrategy } from './types/enums/AuthenticationStrategy';
/** The default, user-friendly base username for FIDO authenticators. */
export const DEFAULT_FIDO_NAME = 'Mastercard';
/**
 * List of strategies with their respective associated authentication method types.
 *
 * The order of this list dictates the execution order of strategies
 * (e.g., when FIDO2 is not applicable, the next strategy in line would be LVLR).
 *
 * See {@link https://example.com/some-link Strategies} for more info.
 */
export const STRATEGIES = [
    {
        strategy: AuthenticationStrategy.MDES,
        types: [
            // (APP_* not yet supported)
            // AuthenticationMethodType.APP_AUTHENTICATON,
            // AuthenticationMethodType.APP_OTP,
            AuthenticationMethodType.SMS_OTP,
            AuthenticationMethodType.EMAIL_OTP
        ]
    },
    {
        strategy: AuthenticationStrategy.FIDO2,
        types: [AuthenticationMethodType.FIDO2]
    },
    {
        strategy: AuthenticationStrategy.LVLR,
        types: [AuthenticationMethodType.LVLR]
    },
    {
        strategy: AuthenticationStrategy.THREE_DS,
        types: [AuthenticationMethodType.THREE_DS]
    }
];
/**
 * Default `MANAGED_AUTHENTICATION` method types.
 *
 * See {@link https://example.com/some-link Managed Authentication} for more info.
 */
export const DEFAULT_MANAGED_AUTH_METHODS = [
    AuthenticationMethodType.LVLR,
    AuthenticationMethodType.FIDO2,
    AuthenticationMethodType.THREE_DS
];
//# sourceMappingURL=constants.js.map